<template>
	<edit-user-form form-type="preferences">
		<template #default="{ form, canEdit, update }">
			<p class="subtitle-1">
				Check-In alerts are
				<strong v-if="form.checkin === false">
					<em>not</em>
				</strong>
				active on this resident.
			</p>
			<!-- todo: add icons and logic to show checkin state -->
			<v-switch
				v-model="form.data.checkin"
				label="Check-In Alerts"
				:disabled="!(canEdit && hasCheckinRole)"
				:hide-details="hasCheckinRole"
				persistent-hint
				hint="You can only edit this preference if you have the Check-in role"
				@change="update(['checkin', $event])"
			></v-switch>
		</template>
	</edit-user-form>
</template>

<script>
import EditUserForm from "./EditUserForm.vue";
import ability from "@/services/ability"

export default {
	components: { EditUserForm },

	computed: {
		hasCheckinRole() {
			return ability.can("Check-in", "Users");
		},
	},
};
</script>
